import { createAsyncThunk } from '@reduxjs/toolkit';
import { REDUX_ACTION, selectApi, setReduxAction, upload } from '@socialive/common';
import { selectUploads } from '~/selectors';
import { onProgress } from '~/slice';

// STUD-5837: Update to use throttle and revamp how we handle progress
const uploadChunk = createAsyncThunk(
  'uploads/uploadChunk',
  async (
    { bucket, blob, partNumber, uploadId, filename, id, contentType, retry = 5, trigger },
    { dispatch, getState }
  ) => {
    const api = selectApi(getState());
    if (!api) throw new Error('API is required');

    let attempt = 0;
    let intervalId;

    const chunkUpload = async () => {
      try {
        let progress = 0;
        attempt += 1;

        intervalId = setInterval(async () => {
          await dispatch(onProgress({ id, progress, trigger }));
        }, 300);

        const { url } = await api(`/s3-secure/multipart/signed-part/${bucket}/${partNumber}/${filename}`, {
          method: 'POST',
          data: {
            uploadId,
          },
        });

        const xhr = await upload(url, {
          data: blob,
          id,
          headers: { 'Content-Type': contentType },
          onProgress: ({ loaded }) => {
            progress = loaded;
          },
        });

        return xhr.getResponseHeader('ETag');
      } catch (e) {
        const { canceling } = selectUploads(getState())[id] ?? {};
        if (canceling || attempt > retry) throw e;
        return chunkUpload();
      } finally {
        clearInterval(intervalId);
      }
    };

    const tagId = await chunkUpload();
    await dispatch(onProgress({ id, progress: blob.size, trigger }));

    return { tagId, attempt };
  }
);

setReduxAction(REDUX_ACTION.UPLOAD_CHUNK, uploadChunk);

export default uploadChunk;
